export default __webpack_public_path__ + "static/media/bottle.d65bd46a.svg";